import React from "react";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TableSortLabel,
  Typography, Box
} from "@mui/material";

export interface Summary {
  date: string;
  symbol: string;
  trades: number;
  pnl: number;
}

interface TradeSummaryProps {
  summaryList: Summary[];
  sortField: keyof Summary;
  sortDirection: "asc" | "desc";
  onSort: (field: keyof Summary) => void;
  onSelect: (sel: { date: string; symbol: string }) => void;
}

export default function TradeSummary({ summaryList, sortField, sortDirection, onSort, onSelect }: TradeSummaryProps) {
  const mkHdr = (key: keyof Summary, label: string, align: "left" | "right") => (
    <TableCell align={align} sx={{ fontWeight: 'bold' }}>
      <TableSortLabel
        active={sortField === key}
        direction={sortField === key ? sortDirection : "asc"}
        onClick={() => onSort(key)}
      >{label}</TableSortLabel>
    </TableCell>
  );
  return (
    <TableContainer component={Paper}>
      <Box p={2}><Typography variant="h6">Trade Summary</Typography></Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            {mkHdr("date", "Date", "left")}
            {mkHdr("symbol", "Symbol", "left")}
            {mkHdr("trades", "Trades", "right")}
            {mkHdr("pnl", "PnL", "right")}
          </TableRow>
        </TableHead>
        <TableBody>
          {summaryList.map(r => (
            <TableRow key={`${r.date}_${r.symbol}`} hover sx={{ cursor: 'pointer' }} onClick={() => onSelect({ date: r.date, symbol: r.symbol })}>
              <TableCell>{r.date}</TableCell>
              <TableCell>{r.symbol}</TableCell>
              <TableCell align="right">{r.trades}</TableCell>
              <TableCell align="right">{r.pnl.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}